/**
 * Traducciones ES → EN del componente Ajustes.tsx (pantalla de ajustes del vault).
 * La clave es la cadena en español EXACTA envuelta con `t()` en el código; el valor su inglés.
 * NO se traducen nombres propios (Telegram, TWAP), símbolos de token, direcciones ni números.
 */
export const AJUSTES: Record<string, string> = {
  // --- Secciones ---
  "Estrategia": "Strategy",
  "Cómo y cuándo gana dinero la piscina. Aquí va lo que tocas más.":
    "How and when the pool makes money. This is what you adjust most.",
  "Ante caídas": "On drops",
  "Qué hace el robot cuando el precio se mueve en tu contra. Protección automática.":
    "What the robot does when the price moves against you. Automatic protection.",
  "Guardias del reajuste": "Rebalance guards",
  "Protecciones técnicas contra manipulación de precios. Casi nunca necesitan cambios.":
    "Technical protections against price manipulation. Rarely need changes.",
  "El robot": "The robot",
  "Quién gestiona la posición y cómo enterarte de lo que hace.":
    "Who manages the position and how to keep track of what it does.",

  // --- Ayuda contextual ---
  "Más información": "More information",

  // --- Ancho del rango ---
  "Ancho del rango": "Range width",
  "El": "The",
  "semiancho": "half-width",
  "(±% del precio) determina cuánta comisión cobras y cuánto gas gasta el robot.":
    "(±% of the price) determines how much fee you collect and how much gas the robot spends.",
  "Semiancho del rango (ticks)": "Range half-width (ticks)",
  "Más estrecho (números bajos):": "Narrower (low numbers):",
  "cobras más comisión cada vez, pero el robot reajusta más a menudo (gasta más gas).":
    "you collect more fees each time, but the robot rebalances more often (spends more gas).",
  "Más ancho (números altos):": "Wider (high numbers):",
  "menos comisiones, menos reajustes, menos gas.":
    "fewer fees, fewer rebalances, less gas.",
  "Límites: mínimo": "Limits: minimum",
  "(exigido por la pool), máximo": "(required by the pool), maximum",
  "ticks.": "ticks.",
  "Cambiar el ancho del rango": "Change the range width",
  "El ancho nuevo se usa en el PROXIMO reajuste. La posición de ahora no se toca.":
    "The new width is used on the NEXT rebalance. The current position is not touched.",
  "Semiancho ahora": "Half-width now",
  "Semiancho nuevo": "New half-width",
  "{n} ticks": "{n} ticks",
  "Guardar rango": "Save range",

  // --- Guardias del reajuste ---
  "Protegen contra manipulación: si el precio spot se aleja demasiado del precio medio (TWAP), la transacción revierte.":
    "They protect against manipulation: if the spot price drifts too far from the average price (TWAP), the transaction reverts.",
  "Ventana del TWAP (s)": "TWAP window (s)",
  "Desviación máxima (ticks)": "Maximum deviation (ticks)",
  "Deslizamiento máx. (bps)": "Max. slippage (bps)",
  "Entre reajustes (s)": "Between rebalances (s)",
  "Cambiar las guardias": "Change the guards",
  "Son lo que hace seguro que el robot dispare mirando el precio spot: si spot y TWAP se separan mas de la desviacion, la transaccion revierte.":
    "They are what makes it safe for the robot to fire based on the spot price: if spot and TWAP diverge more than the deviation, the transaction reverts.",
  "Ventana del TWAP": "TWAP window",
  "{a} s  →  {b} s": "{a} s  →  {b} s",
  "Desviacion maxima": "Maximum deviation",
  "{a}  →  {b} ticks": "{a}  →  {b} ticks",
  "Deslizamiento": "Slippage",
  "{a}  →  {b} bps": "{a}  →  {b} bps",
  "Tiempo entre reajustes": "Time between rebalances",
  "Una desviación alta deja pasar precios más manipulables.":
    "A high deviation lets more manipulable prices through.",
  "Guardar guardias": "Save guards",

  // --- Reinyección (Comprar si el precio baja) ---
  "Comprar si el precio baja": "Buy if the price drops",
  "Suelta dinero poco a poco cuando el precio cae, para comprar más barato (acumulación automática).":
    "Releases funds bit by bit when the price falls, to buy cheaper (automatic accumulation).",
  "Cuándo reinyectar": "When to reinject",
  "Nunca — dinero dormido": "Never — idle funds",
  "En cada reajuste del rango": "On every range rebalance",
  "Cada vez que el precio cae otro tanto (%)": "Each time the price falls by another amount (%)",
  "Cuánto suelta (% de la reserva original)": "How much to release (% of the original reserve)",
  "Por cada caída de (%)": "For every drop of (%)",
  "Tramos ya usados:": "Steps already used:",
  "Evita reinyectar de más.": "Avoids over-reinjecting.",
  "Cambiar la reinyección": "Change the reinjection",
  "Decide cuándo se suelta la reserva que tienes apartada.":
    "Decides when the reserve you have set aside is released.",
  "Cuándo": "When",
  "Nunca": "Never",
  "En cada reajuste": "On every rebalance",
  "Por cada caída": "On every drop",
  "Cuánto suelta": "How much it releases",
  "{pct}% de la reserva original": "{pct}% of the original reserve",
  "Por cada caída de": "For every drop of",
  "{caida}%": "{caida}%",
  "Con «nunca» la reserva no hace nada — está parada.":
    "With “never” the reserve does nothing — it sits idle.",
  "Guardar reinyección": "Save reinjection",

  // --- Recuperación ---
  "Recuperar tras una caída": "Recover after a drop",
  "Cuando el precio se sale por abajo, el rango se estira automáticamente para recuperar tu capital. Sin esto, el reajuste normal re-centra y cristaliza la pérdida.":
    "When the price exits below, the range stretches automatically to recover your capital. Without this, a normal rebalance re-centers and locks in the loss.",
  "Estirar el rango para recuperar el capital": "Stretch the range to recover the capital",
  "Vender lo mínimo para que la posición nazca DENTRO del rango":
    "Sell the minimum so the position is created INSIDE the range",
  "Estiramiento máximo (ticks)": "Maximum stretch (ticks)",
  "Venta máxima (% del saldo)": "Maximum sale (% of the balance)",
  "Cambiar la recuperación": "Change the recovery",
  "Es lo que evita cristalizar la pérdida cuando el precio se sale por abajo: en vez de re-centrar, el rango se estira hacia donde tiene que volver.":
    "It is what prevents locking in the loss when the price exits below: instead of re-centering, the range stretches toward where it needs to return.",
  "Recuperación": "Recovery",
  "activada": "enabled",
  "APAGADA": "OFF",
  "Estiramiento máximo": "Maximum stretch",
  "Vender el mínimo": "Sell the minimum",
  "sí": "yes",
  "no": "no",
  "Venta máxima": "Maximum sale",
  "{n}%": "{n}%",
  "Apagada: un reajuste con el precio por debajo": "Off: a rebalance with the price below",
  "re-centra y pierde dinero": "re-centers and loses money",
  "Guardar recuperación": "Save recovery",

  // --- Colchón ---
  "Salir con algo de sobra": "Exit with a bit to spare",
  "El rango de recuperación apunta a devolverte exactamente lo que pusiste. Un":
    "The recovery range aims to give you back exactly what you put in. A",
  "colchón": "buffer",
  "añade un margen extra que cubre el coste real de salir (comisión, slippage, 0,10% conversión).":
    "adds an extra margin that covers the real cost of exiting (fee, slippage, 0.10% conversion).",
  "Colchón sobre el capital (%)": "Buffer over the capital (%)",
  "Capital:": "Capital:",
  "Colchón:": "Buffer:",
  "El rango apuntará a:": "The range will aim at:",
  "Piscinas nuevas nacen con": "New pools are created with",
  "0,5%": "0.5%",
  "(costo estándar en pools 0,05%–0,3%). En pools del 1% sube a":
    "(standard cost in 0.05%–0.3% pools). In 1% pools it rises to",
  "1–2%": "1–2%",
  "Máximo: 5% (más ancho = menos comisiones).": "Maximum: 5% (wider = fewer fees).",
  "Cambiar el colchón": "Change the buffer",
  "Hasta dónde apunta el rango cuando está recuperando una caída.":
    "How far the range aims when it is recovering from a drop.",
  "Colchón": "Buffer",
  "ninguno — al capital pelado": "none — to the bare capital",
  "{pct}% por encima": "{pct}% above",
  "Capital": "Capital",
  "El rango apuntará a": "The range will aim at",
  "Sin colchón el rango apunta al capital exacto.": "Without a buffer the range aims at the exact capital.",
  "Salir de verdad cuesta más": "Actually exiting costs more",
  "Colchón mayor = rango más ancho =": "Bigger buffer = wider range =",
  "menos comisiones": "fewer fees",
  "Guardar colchón": "Save buffer",

  // --- Reinversión ---
  "Qué hacer con lo ganado": "What to do with the earnings",
  "Ahora mismo las ganancias": "Right now the earnings",
  "se reinvierten": "are reinvested",
  "se apartan": "are set aside",
  "Reinvierten": "Reinvested",
  "Vuelven a trabajar en la posición → más comisiones.":
    "They go back to work in the position → more fees.",
  "Se apartan": "Set aside",
  "Tú controlas cuándo retirarte ese dinero.": "You control when to withdraw that money.",
  "Apartar las ganancias": "Set aside the earnings",
  "Reinvertir las ganancias": "Reinvest the earnings",
  "Las ganancias volverán a apartarse. Ni el reajuste ni el barrido pueden tocarlas: solo tú decides.":
    "The earnings will be set aside again. Neither the rebalance nor the sweep can touch them: only you decide.",
  "Las ganancias dejarán de apartarse y volverán a la posición a generar más comisiones.":
    "The earnings will stop being set aside and return to the position to generate more fees.",
  "Ahora": "Now",
  "Después": "After",
  "Apartar": "Set aside",
  "Reinvertir": "Reinvest",

  // --- Cuota ---
  "Permisos del robot": "Robot permissions",
  "Quedan": "Remaining",
  "reajustes.": "rebalances.",
  "Sin cuota, el robot no reajusta. Recarga ahora.":
    "Without quota, the robot won't rebalance. Top up now.",
  "Pocas quedan. Recargue pronto.": "Few remaining. Top up soon.",
  "Añadir reajustes": "Add rebalances",
  "Recargar la cuota": "Top up the quota",
  "La cuota es cuántos reajustes permites. Es un contador aparte de la bolsa de gas: el gas paga, la cuota autoriza.":
    "The quota is how many rebalances you allow. It is a separate counter from the gas pot: gas pays, the quota authorizes.",
  "{n} reajustes": "{n} rebalances",
  "Recargar cuota": "Top up quota",

  // --- Robot ---
  "Es lo ÚNICO que puede hacer: reajustar tu rango. No puede sacar dinero ni cambiar ajustes.":
    "It is the ONLY thing it can do: rebalance your range. It cannot withdraw funds or change settings.",
  "Operador actual": "Current operator",
  "Reanudar el robot": "Resume the robot",
  "Pausar el robot": "Pause the robot",
  "El robot vuelve a reajustar tu rango cuando el precio se salga.":
    "The robot resumes rebalancing your range when the price exits.",
  "El robot deja de reajustar. Tu dinero no se mueve, pero si el precio se sale dejas de cobrar y nadie lo corrige.":
    "The robot stops rebalancing. Your funds don't move, but if the price exits you stop collecting and no one corrects it.",
  "Reanudar": "Resume",
  "Pausar": "Pause",
  "Detener el robot": "Stop the robot",
  "Quita el operador del vault. Nadie podrá reajustar tu rango hasta que vuelvas a poner uno.":
    "Removes the operator from the vault. No one will be able to rebalance your range until you set a new one.",
  "Tu dinero": "Your funds",
  "no se mueve, sigue en la posición": "don't move, they stay in the position",
  "Reajustes": "Rebalances",
  "ninguno, hasta que pongas otro operador": "none, until you set another operator",
  "Si el precio se sale del rango, dejas de cobrar y nadie lo corregirá.":
    "If the price exits the range, you stop collecting and no one will correct it.",
  "Cambiar robot": "Change robot",
  "dirección": "address",
  "Cambiar el robot": "Change the robot",
  "Solo esa dirección podrá reajustar tu rango. Seguirá sin poder mover tu dinero ni cambiar tus ajustes.":
    "Only that address will be able to rebalance your range. It still won't be able to move your funds or change your settings.",
  "Si pones una dirección que no controlas, tu vault se queda sin gestión automática.":
    "If you set an address you don't control, your vault is left without automatic management.",

  // --- Actualizar la lógica ---
  "Actualizar la lógica": "Update the logic",
  "Hay una versión más reciente del código que gestiona tu posición.":
    "There is a newer version of the code that manages your position.",
  "Qué mejora": "What it improves",
  "Algunas mejoras nuevas solo están en vaults creados desde cero con esta versión; en este vault se adopta el algoritmo de reajuste mejorado.":
    "Some new improvements are only in vaults created from scratch with this version; in this vault the improved rebalance algorithm is adopted.",
  "Actualizar": "Update",
  "no mueve tu dinero": "does not move your funds",
  "no cierra la posición ni cambia tus ajustes: solo cambia el código que ejecuta los reajustes de ahora en adelante. Solo tú puedes hacerlo.":
    "does not close the position or change your settings: it only changes the code that runs the rebalances from now on. Only you can do it.",
  "Disponible": "Available",
  "Tu vault pasa a ejecutar el código que publica su factory.":
    "Your vault switches to running the code its factory publishes.",
  "No mueve tu dinero": "It does not move your funds",
  "no cierra la posición ni cambia tus ajustes.": "does not close the position or change your settings.",
  "Solo tú puedes hacerlo, y solo puede apuntar a lo que publica tu factory. Nadie más puede cambiar tu código.":
    "Only you can do it, and it can only point to what your factory publishes. No one else can change your code.",
  "Actualizando…": "Updating…",
  "Actualizar a la última versión": "Update to the latest version",

  // --- Novedades de lógica (V2) ---
  "Recupera mejor tras una caída: la posición de recuperación nace ya dentro del rango y vende lo mínimo, en vez de malvender de golpe.":
    "Recovers better after a drop: the recovery position is created already inside the range and sells the minimum, instead of dumping all at once.",
  "Decide la salida con el precio real del momento, no con un promedio: deja de cristalizar pérdidas cuando el mercado está fino.":
    "Decides the exit with the real current price, not an average: it stops locking in losses when the market is thin.",
  "Tu ganancia ya apartada no se toca en ningún reajuste.":
    "Your earnings already set aside are not touched in any rebalance.",
  "Vuelve solo al rango estrecho sin vender tu activo cuando el precio regresa.":
    "Returns on its own to the narrow range without selling your asset when the price comes back.",
  "Colchón de recuperación configurable: eliges cuánto margen dejar sobre tu capital.":
    "Configurable recovery buffer: you choose how much margin to leave above your capital.",
  "Reparto de referidos activo en las comisiones.":
    "Referral sharing active on the fees.",

  // --- Avisos por Telegram ---
  "Avisos por Telegram": "Telegram alerts",
  "Avisos por Telegram · activos": "Telegram alerts · active",
  "Los avisos no están disponibles ahora mismo.": "Alerts are not available right now.",
  "No pude hablar con el servidor de avisos.": "I couldn't reach the alerts server.",
  "El bot todavía no está configurado en el servidor.": "The bot is not yet configured on the server.",
  "Recibe notificaciones de": "Get notifications about",
  "todas tus piscinas": "all your pools",
  "en las tres redes: cuando se salen de rango, cuando el robot las recentra, cuando el gas o la cuota se quedan cortos.":
    "across the three networks: when they go out of range, when the robot re-centers them, when gas or quota runs low.",
  "Se conecta una sola vez — las piscinas que abras después entran solas. Se firma un":
    "It connects only once — pools you open later are added automatically. You sign a",
  "mensaje": "message",
  "(sin gas, sin transacción).": "(no gas, no transaction).",
  "Consultando…": "Checking…",
  "Abre el enlace y pulsa": "Open the link and press",
  "en Telegram. Esta pantalla se pone al día sola en cuanto lo hagas.":
    "in Telegram. This screen updates itself as soon as you do.",
  "Abrir Telegram ↗": "Open Telegram ↗",
  "Firmando…": "Signing…",
  "Conectar Telegram": "Connect Telegram",
  "Chat conectado": "Connected chat",
  "Piscinas vigiladas": "Pools watched",
  " — se añaden solas al abrir la primera": " — they are added automatically when you open the first one",
  "Qué quieres que te avise:": "What you want to be alerted about:",
  "Desconectando…": "Disconnecting…",
  "Desconectar Telegram": "Disconnect Telegram",

  // --- TIPOS_AVISO (definidos en useAvisos.ts, renderizados aquí con t()) ---
  "Se sale o vuelve al rango": "Exits or returns to range",
  "Con el precio, tu banda y cuánto se salió": "With the price, your band and how far it exited",
  "El robot reajusta": "The robot rebalances",
  "De qué banda a qué banda la movió": "From which band to which band it moved it",
  "La bolsa de gas se vacía": "The gas pot runs empty",
  "Sin gas el robot deja de trabajar": "Without gas the robot stops working",
  "Se acaban los reajustes": "Rebalances run out",
  "Avisa al bajar de 25 y al llegar a 0": "Alerts when it drops below 25 and when it reaches 0",
  "Se cobran comisiones": "Fees are collected",
  "Cuánto se apartó y qué % es de tu capital": "How much was set aside and what % it is of your capital",
  "Llega a tu objetivo": "Reaches your target",
  "La piscina se cierra sola y queda en el estable": "The pool closes on its own and settles into the stable",
  "Se reinyecta el colchón": "The buffer is reinjected",
  "Cuánto entró a trabajar y cuánto queda": "How much went to work and how much is left",
  "La pausas o la reanudas": "You pause or resume it",
  "Confirma que el robot paró o volvió": "Confirms the robot stopped or resumed",
};
